import Stack from '@mui/material/Stack';
import React from 'react';
import { ProgressionListContent } from '@/components/chord_progression/converter/progression_list/ProgressionListContent';
import { ProgressionListLabel } from '@/components/chord_progression/converter/progression_list/ProgressionListLabel';
import { Progression } from '@/components/chord_progression/converter/types';

export const ProgressionList = (props: {
  label: string;
  progressions: Progression[];
}) => (
  <Stack spacing={0.5}>
    <ProgressionListLabel>{props.label}</ProgressionListLabel>
    <ProgressionListContent progressions={props.progressions} />
  </Stack>
);
